function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.34933 14.8574C5.38553 14.8574 2 15.4697 2 17.9171C2 20.3663 5.364 20.9997 9.34933 20.9997C13.3131 20.9997 16.6987 20.3874 16.6987 17.9401C16.6987 15.4908 13.3347 14.8574 9.34933 14.8574Z",
  fill: "#8B8B8B"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M9.34935 12.5248C12.049 12.5248 14.2124 10.4062 14.2124 7.76241C14.2124 5.11865 12.049 3 9.34935 3C6.65072 3 4.48633 5.11865 4.48633 7.76241C4.48633 10.4062 6.65072 12.5248 9.34935 12.5248Z",
  fill: "#8B8B8B"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M16.1735 7.84922C16.1735 9.19553 15.7606 10.4518 15.0365 11.4953C14.9612 11.6026 15.0277 11.7473 15.1588 11.7703C15.3408 11.8 15.5277 11.8182 15.7185 11.822C17.6168 11.8709 19.3203 10.6741 19.791 8.87165C20.4886 6.19723 18.4416 3.7959 15.834 3.7959C15.5512 3.7959 15.2802 3.82465 15.016 3.87735C14.9798 3.88501 14.9406 3.90226 14.9211 3.93293C14.8956 3.97221 14.9142 4.023 14.9397 4.05654C15.7234 5.13263 16.1735 6.44253 16.1735 7.84922Z",
  fill: "#8B8B8B"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7792 15.1697C21.4318 14.4444 20.5933 13.947 19.3174 13.7027C18.7156 13.559 17.0854 13.3548 15.5698 13.3836C15.5473 13.3865 15.5346 13.4018 15.5326 13.4114C15.5297 13.4267 15.5365 13.4497 15.5659 13.466C16.2665 13.8052 18.9739 15.2809 18.6334 18.3932C18.6187 18.5293 18.7293 18.6443 18.8673 18.6251C19.5336 18.5322 21.2479 18.1709 21.7792 17.0479C22.0737 16.4538 22.0737 15.7638 21.7792 15.1697Z",
  fill: "#8B8B8B"
});
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.8281cd69.svg";
export { ForwardRef as ReactComponent };